import { AbstractSelectorResultController } from '../selector-result-controllers/abstract-selector-result-controller';

class ReportController extends AbstractSelectorResultController {

  connectedCallback () {
    super.connectedCallback();
  }

  disconnectedCallback () {
    super.disconnectedCallback();
  }

}

customElements.define('d-report-controller', ReportController);
